import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollFunction({ history }) {
  // const location = useLocation();

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0,0);
    });
    return () => {
      unlisten();
    }
  }, [history]);

  return (null);
}

export default withRouter(ScrollFunction);